import { handleActions } from 'redux-actions';
import { EMPLOYEE } from '../../lib/user';

import * as constants from './constants';

export const initialState = {
  id: 0,

  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  active: true,

  role: EMPLOYEE,

  locations: [],

  dailyReviewDigest: false,
  reportingPlus: false,
};

function setUser(state, { payload }) {
  const user = payload;

  const {
    id,
    firstName,
    lastName,
    email,
    phone,
    role,
    locations,
    dailyReviewDigest,
    reportingPlus,
    active,
  } = user;

  return {
    ...state,
    id,
    firstName,
    lastName,
    email,

    role: role || initialState.role,

    phone: phone || initialState.phone,

    locations,

    dailyReviewDigest,
    reportingPlus,
    active: Boolean(active),
  };
}

function updateRole(state, { payload }) {
  const role = payload;

  return { ...state, role };
}

function updateFirstName(state, { payload }) {
  const firstName = payload;

  return { ...state, firstName };
}

function updateLastName(state, { payload }) {
  const lastName = payload;

  return { ...state, lastName };
}

function updateEmail(state, { payload }) {
  const email = payload;

  return { ...state, email };
}

function updatePhone(state, { payload }) {
  const phone = payload;

  return { ...state, phone };
}

export default handleActions(
  {
    [constants.UPDATE_ROLE]: updateRole,
    [constants.UPDATE_FIRST_NAME]: updateFirstName,
    [constants.UPDATE_LAST_NAME]: updateLastName,
    [constants.UPDATE_EMAIL]: updateEmail,
    [constants.UPDATE_PHONE]: updatePhone,

    [constants.SET_USER]: setUser,
  },
  initialState
);
